import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { site } from '@yola/ws-sdk';
import sortAlphabetically from 'src/js/modules/common/helpers/sort-alphabetically';

const usePagesOptions = () => {
  const pages = useSelector(site.selectors.getPages);
  const activePageId = useSelector(site.selectors.getActivePageId);

  const pagesOptions = useMemo(
    () =>
      pages
        .map(({ id, name, locale }) => ({ value: id, label: name, locale }))
        .sort((a, b) => {
          if (a.value === activePageId) return -1;
          if (b.value === activePageId) return 1;
          return sortAlphabetically(a.label, b.label);
        }),
    [pages, activePageId]
  );

  return { pagesOptions };
};

export default usePagesOptions;
